import { useCallback, useState } from 'react';

interface LocationCoords {
  lat: number;
  lon: number;
}

export function useLocationPopover() {
  const [locationPopoverVisible, setLocationPopoverVisible] = useState<boolean>(false);
  const [locationPopoverCoords, setLocationPopoverCoords] = useState<LocationCoords | null>(null);

  const showLocationPopover = useCallback((event: any) => {
    const [longitude, latitude] = event.coordinate;

    // Normalize longitude to [-180, 180] range
    const normalizedLongitude = ((((longitude + 180) % 360) + 360) % 360) - 180;

    // Set coordinates and show the popover
    setLocationPopoverCoords({ lat: latitude, lon: normalizedLongitude });
    setLocationPopoverVisible(true);
  }, []);

  const hideLocationPopover = useCallback(() => {
    setLocationPopoverVisible(false);
    setLocationPopoverCoords(null);
  }, []);

  return {
    locationPopoverVisible,
    locationPopoverCoords,
    showLocationPopover,
    hideLocationPopover,
  };
}
